import { get } from "http";

export default{
  rs(state){
    return state.resourcelist
  },
  salesrs(state){
    return state.salesresourcelist
  },
  se(state){
    return state.selectlist
  },
  languagetype(state){
    return state.languagetype
  },
  logintype(state){
    return state.logintype
  },
  control(state){
    return state.control
  },
  controlrouter(state){
    return state.controlrouter
  },
  saleAdviceData(state){
    return state.saleAdviceData
  },
  saleAdviceDataAtt(state){
    return state.saleAdviceDataAtt
  },
  btnStatus(state){
    return state.btnStatus
  },
  navPathList(state){
    return state.navPathList
  },
  watingTotal(state){ //等待审批数量,小红点
    return state.waitingTotal
  },
  channelWatingTotal(state){ //等待审批数量,小红点(渠道)
    return state.channelWaitingTotal
  },
  navcollapse(state){
    return state.navcollapse
  },

  GET_SHOW_LOADING(state){
    return state.show_loading
  },
  allprojectTab(state){
    return state.allprojecttab
  },
  reaTab(state){
    return state.reatab
  },
  domainTab(state){
    return state.domaintab
  },
  agentboxTab(state){
    return state.agentboxtab
  },
  campaignHostTab(state){
    return state.campaignHostTab
  },
  approvalTab(state){
    return state.approvaltab
  },
  sharedListingTab(state){
    return state.sharedlistingtab
  },
  listingApprovalTab(state){
    return state.listingapprovaltab
  },
  marketplaceTab(state){
    return state.marketplacetab
  },
  marketplaceSubtab(state){
    return state.marketplacesubtab
  },
  menuActive(state){
    return state.menuactive
  },
  menuNav(state){
    return state.menunav
  },
  internalPendingCount(state){
    return state.internalpendingcount
  },
  marketplacePendingCount(state){
    return state.marketplacependingcount
  },
  contactBulkUnlock(state){
    return state.contactBulkUnlock
  },
  departmentTab(state){
    return state.departmenttab
  },
  projectType(state){
    return state.projectType;
  },
  CAMPAIGN_DATA(state){
    return state.campaignData
  },
  SINGLE_LIST_DATA(state){
    return state.singleListData
  },
  SHARED_LIST_DATA(state){
    return state.sharedListData
  },
  logoimagedark(state){
    return state.logoimagedark
  },
  sessionExpired(state){
    return state.sessionExpired
  },
  token(state){
    return state.token
  },
  edition(state){
    return state.edition
  },
  commissionModuleEnabled(state){
    return state.commissionModuleEnabled
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js